import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles from './Styles/Skeleton.Style'

const MonitoringUpdateSkeleton: React.FC = () => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.skeletonContainer}>
        <Skeleton animation="wave" className={classes.skeletonRow} />
        <Skeleton animation="wave" className={classes.skeletonRow} />
        <Skeleton animation="wave" className={classes.skeletonRow} />
        <Skeleton animation="wave" className={classes.skeletonRow} />
        <Skeleton animation="wave" className={classes.skeletonRow} />
        <Skeleton animation="wave" className={classes.skeletonRow} />
      </div>
    </>
  )
}

export default MonitoringUpdateSkeleton
